module.exports = __webpack_public_path__ + "static/media/nailcare.69407e33.svg";